import { createTheme, type MantineColorsTuple } from "@mantine/core";

/** Teal-blue "basin" palette, the primary colour of the app. */
const basin: MantineColorsTuple = [
  "#e5f8fa",
  "#d3eef1",
  "#a8dce3",
  "#79c9d4",
  "#53b9c7",
  "#3aafbf",
  "#29a9bb",
  "#1693a4",
  "#008393",
  "#00717f",
];

export const theme = createTheme({
  primaryColor: "basin",
  primaryShade: { light: 8, dark: 6 },
  colors: { basin },
  defaultRadius: "md",
  fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  headings: { fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif", fontWeight: "650" },
  components: {
    Card: { defaultProps: { withBorder: true, radius: "lg", padding: "lg" } },
    Paper: { defaultProps: { radius: "lg" } },
    Button: { defaultProps: { radius: "md" } },
  },
});

/** Series colours shared by the charts (colour-blind safe, Okabe-Ito based). */
export const SERIES_COLORS = ["#0072B2", "#E69F00", "#009E73", "#CC79A7", "#56B4E9", "#D55E00", "#F0E442", "#000000"];
